import React, { useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import ProformaGenerationsTable from "../../components/ProformaGenerationsTable";
import styles from "./index.module.css";
import useDebounce from "../../hooks/useDebounce";
import { useState } from "react";
import { createProformaGenerationRecord, downloadTemplateApi, uploadTemplateApi } from "../../service/api";
import { showNotification } from "../../service/showNotification";
import { GlobalModal } from "../../helper/GlobalModal";
import { ProformaForm } from "../../components/ProformaGenerationsForm";
import { tracker } from "../../service/mixpanel";
import { isProduction } from "../../utils/constant";

const ProformaGenerations = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isAdded, setIsAdded] = useState(false);
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const [isDownloading, setIsDownloading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleDownloadTemplate = async () => {

    setIsDownloading(true);
    try {
      const response = await downloadTemplateApi();
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      const timestamp = Date.now();
      link.setAttribute("download", `Master_Template_${timestamp}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      showNotification("success", "Template downloaded started");
    } catch (error) {
      showNotification("error", "Failed to download template");
    } finally {
      setIsDownloading(false);
    }
  };

  const handleUploadTemplate = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    setIsUploading(true);
    try {
      const response = await uploadTemplateApi(file);
      showNotification("success", response?.data?.message || "Template uploaded successfully");
    } catch (error) {      
      showNotification("error", error?.response?.data?.message || "Failed to upload template");
    } finally {
      setIsUploading(false);
      if (fileInputRef.current) fileInputRef.current.value = "";
    }
  };

  useEffect(() => {
    tracker.proformaGeneration.pageView();
  }, []);

  const handleModal = () => {
    tracker.proformaGeneration.generateProformaClick();
    setShowModal(!showModal);
  };

  const handleCreateProformaRecord = async (data) => {
    tracker.proformaGeneration.submitProformaClick();
    setSubmitLoading(true);
    try {
      const response = await createProformaGenerationRecord(data);
      if (response?.data?.success) {
        showNotification("success", "Proforma created successfully");
      }
    } catch (error) {
      showNotification("error", "Failed to create proforma");
    } finally {
      setSubmitLoading(false);
      handleModal();
      setIsAdded(true);
    }
  };

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.headerWrapper}>
          <div className={styles.headerLeft}>
            <h4 className="mb-0">Proforma Generations</h4>
          </div>

          <div className={styles.headerRight}>
            <input
              type="search"
              placeholder="Search Proforma ID"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className={styles.searchInput}
            />
            <Button className={styles.proformaButton} onClick={handleModal}>
              Add Proforma Record
            </Button>
          </div>
        </div>
        {/* TODO - REMOVE THIS WHEN PROFORMA IS DEPLOYED ON PROD */}
          <div className={styles.templateSection}>
            <div className={styles.templateInfo}>
              <h5>Master Template Management</h5>
              <p>
                Download the current base template or upload a new version to
                update the system.
              </p>
            </div>

            <div className={styles.templateActions}>
              <Button
                className={`${styles.proformaButton} ${styles.templateBtn}`}
                onClick={handleDownloadTemplate}
                disabled={isDownloading}
              >
                {isDownloading ? "Downloading..." : "Download Template"}
              </Button>

              <input
                type="file"
                accept=".xlsx, .xls, .csv"
                ref={fileInputRef}
                style={{ display: "none" }}
                onChange={handleUploadTemplate}
              />

              <Button
                className={`${styles.proformaButton} ${styles.templateBtn}`}
                onClick={() => fileInputRef.current?.click()}
                disabled={isUploading}
              >
                {isUploading ? "Uploading..." : "Upload New Template"}
              </Button>
            </div>
          </div>

        <div></div>
        <ProformaGenerationsTable
          searchTerm={debouncedSearchTerm}
          isAdded={isAdded}
        />
      </div>
      <GlobalModal
        isOpen={showModal}
        onClose={handleModal}
        title="Create Proforma Record"
        size="lg"
        children={
          <ProformaForm
            onCancel={handleModal}
            submitLoading={submitLoading}
            onSubmit={handleCreateProformaRecord}
          />
        }
      ></GlobalModal>
    </>
  );
};

export default ProformaGenerations;
